import { combineReducers } from "@reduxjs/toolkit";
import auth from "./auth/slice";
import metadata from "./metadata/slice";
import exhibitorBulkUploadStatus from "./organisers/bulkUpload/slice";
import productBulkUploadStatus from "./suppliers/bulkUpload/slice";
import badges from "./badges/slice";
import exhibitorCartStatus from "./exhibitors/cartStepper/slice";
import glossaryPopupTermSlice from "./exhibitors/glossaryPopupTerm/slice";

const rootReducer = combineReducers({
  auth,
  metadata,
  exhibitorBulkUploadStatus,
  productBulkUploadStatus,
  badges,
  exhibitorCartStatus,
  glossaryPopupTermSlice,
});

export default rootReducer;
